import { EgretLoadable } from "egret";
 
const adminDeptManagment = EgretLoadable({
  loader: () => import("./admin-department/AdminDeptManagment")
});

const adminDeptAutoRepliesManagment = EgretLoadable({
  loader: () => import("./auto-replies/AdminDeptManagment")
});

const adminPresetRepliesTable = EgretLoadable({
  loader: () => import("./preset-questions/AdminDeptManagment")
});

const adminDeptSmartRepliesManagment = EgretLoadable({
  loader: () => import("./smart-replies/AdminDeptManagment")
});

const adminDeptTicketGuideManagment = EgretLoadable({
  loader: () => import("./ticket-guide/AdminDeptManagment")
});
 

const adminDeptManagmentRoutes = [
  {
        path: "/agentDeptManagement",
        exact: true,
        component: adminDeptManagment
  },
  {
        path: "/agentDeptAutoRepliesManagment",
        exact: true,
        component: adminDeptAutoRepliesManagment
  },
  {
        path: "/agentPresetRepliesManagment",
        exact: true,
        component: adminPresetRepliesTable
  },
  {
        path: "/agentSmartRepliesManagment",
        exact: true,
        component: adminDeptSmartRepliesManagment
  },
  {
        path: "/agentDeptTicketGuideManagment",
        exact: true,
        component: adminDeptTicketGuideManagment
  }
];

export default adminDeptManagmentRoutes;
